import { useState, useEffect } from 'react';
// import axios from '../../api/axios';
import './Jobs.css';
import { TextField } from '@mui/material';
import axiosInstance from '../../api/axios';
const API_BASE_URL = axiosInstance.defaults.baseURL;

function Jobs() {
  // WebSocket connection
    useEffect(() => {
      const timeout = setTimeout(() => {
        const socket = new WebSocket(`ws://${window.location.hostname}:5001/ws`);
  
        socket.onopen = () => {
          // console.log('✅ WebSocket connected');
          socket.send('Hello server');
        };
  
        // socket.onmessage = (event) => {
        //   console.log('📩 Message from server:', event.data);
        // };
  
        socket.onclose = () => {
          console.log('❌ WebSocket disconnected');
        };
      }, 200);
  
      return () => clearTimeout(timeout);
    }, []);
  const [searchTerm, setSearchTerm] = useState('');
  const [jobs, setJobs] = useState([]);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [showSavedOnly, setShowSavedOnly] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('recent');

  const jobsPerPage = 8;
  const [savedJobs, setSavedJobs] = useState(() => {
    const saved = localStorage.getItem('savedJobs');
    return saved ? JSON.parse(saved) : [];
  });

  const toggleSaveJob = (jobId) => {
    let updated;
    if (savedJobs.includes(jobId)) {
      updated = savedJobs.filter((id) => id !== jobId);
    } else {
      updated = [...savedJobs, jobId];
    }
    setSavedJobs(updated);
    localStorage.setItem('savedJobs', JSON.stringify(updated));
  };

  const toggleReadMore = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const isNewPost = (createdAt) => {
    const now = new Date();
    const created = new Date(createdAt);
    const diffTime = now - created;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays < 7; // highlight posts created within last 7 days
  };

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axiosInstance.get('/api/jobs');
        const sorted = response.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setJobs(sorted);
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    };
    fetchJobs();
  }, []);

  const filteredJobs = jobs
    .filter(
      (job) =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !job.draft &&
        (!showSavedOnly || savedJobs.includes(job._id)),
    )
    .sort((a, b) => {
      if (sortBy === 'recent') {
        return new Date(b.createdAt) - new Date(a.createdAt);
      } else if (sortBy === 'popular') {
        return (b.views || 0) - (a.views || 0);
      }
      return 0;
    });

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);

  return (
    <div className="alumni-jobs-main">
      {/* Search bar and toggle button */}
      <div className="alumni-jobs-header">
        <div className="events-search-container">
          <TextField
            variant="outlined"
            placeholder="Search events..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="events-search-field"
            size="small"
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <select
            className="alumni-jobs-select"
            onChange={(e) => setSortBy(e.target.value)}
            value={sortBy}
            style={{
              padding: '0.4rem 0.8rem',
              borderRadius: '4px',
              marginRight: '1rem',
            }}
          >
            <option value="recent">Sort by Recent</option>
            <option value="popular">Sort by Popularity</option>
          </select>

          <button
            className="toggle-saved-button"
            onClick={() => setShowSavedOnly(!showSavedOnly)}
          >
            {showSavedOnly ? 'Show All Jobs' : '🔖 Show Saved Jobs'}
          </button>
        </div>
      </div>

      <div className="alumni-jobs-grid">
        {currentJobs.length > 0 ? (
          currentJobs.map((job) => (
            <div className="alumni-jobs-card" key={job._id}>
              {isNewPost(job.createdAt) && (
                <span className="new-badge">NEW</span>
              )}
              <img
                src={
                  job.image?.filePath
                    ? `${API_BASE_URL}/${job.image.filePath}`
                    : '/logo.png'
                }
                alt="Job"
                className="job-image"
              />

              <h3
                className="alumni-jobs-card-title"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                {job.title}
              </h3>

              <p
                className={`alumni-jobs-card-description ${
                  !expandedDescriptions[job._id] ? 'truncate-description' : ''
                }`}
              >
                {job.description}
              </p>

              {job.description.split(' ').length > 10 && (
                <div
                  className="read-more-toggle"
                  onClick={() => toggleReadMore(job._id)}
                  style={{
                    color: '#007bff',
                    cursor: 'pointer',
                    fontSize: '0.85rem',
                  }}
                >
                  {expandedDescriptions[job._id] ? 'Read less' : 'Read more'}
                </div>
              )}

              <p
                style={{
                  fontSize: '0.8rem',
                  color: '#888',
                  marginBottom: '0.5rem',
                }}
              >
                👁 {job.views || 0} views
              </p>

              <button
                className={`save-job-button ${
                  savedJobs.includes(job._id) ? 'saved' : ''
                }`}
                onClick={() => toggleSaveJob(job._id)}
              >
                {savedJobs.includes(job._id) ? 'Unsave' : 'Save Job'}
              </button>

              <a
                href={job.link}
                target="_blank"
                rel="noopener noreferrer"
                className="alumni-jobs-card-link"
                onClick={() => {
                  axiosInstance.patch(`/api/jobs/${job._id}/view`);
                }}
              >
                Open Job Link
              </a>
            </div>
          ))
        ) : (
          <div className="no-results-message">
            No jobs found for "<strong>{searchTerm}</strong>".
            <br />
            Try a different keyword or{' '}
            <span onClick={() => setSearchTerm('')} className="show-all-link">
              view all jobs
            </span>
            .
          </div>
        )}
      </div>

      {filteredJobs.length > jobsPerPage && (
        <div className="pagination-controls">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <span>
            Page {currentPage} of {Math.ceil(filteredJobs.length / jobsPerPage)}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) =>
                prev < Math.ceil(filteredJobs.length / jobsPerPage)
                  ? prev + 1
                  : prev,
              )
            }
            disabled={
              currentPage === Math.ceil(filteredJobs.length / jobsPerPage)
            }
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default Jobs;
